import React, { useState, useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle,  Grid, TextField } from '@mui/material';
import api from '../api/api';
import Loading from '../components/loading';
import ErrorMessage from '../components/errorMessage';

export default function NotificationModal({ open, onClose, onSaveSuccess }) {

    const [isLoading, setLoading] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');

    useEffect(() => {
        if (open) {
            cleanFields();
            setShowErrorMessage(false);
            setLoading(false);
        }
    }, [open]);

    const saveNotification = (event) => {
        event.preventDefault(); 

        if (!title.trim() || !content.trim()) {
            setShowErrorMessage(true);
            setErrorMessage("Todos os campos são obrigatórios!");
            return;
        }

        const notificationData = {
            title: title,
            content: content,
        };

        setLoading(true);
        api.post("/notifications", notificationData, {
            headers: {
                Authorization: sessionStorage.getItem('token')
            }
        }).then((returnFromApi) => {
            onSaveSuccess(returnFromApi); 
            cleanFields();
            setLoading(false);
        }).catch((returnFromApi) => {
            setShowErrorMessage(true);
            setErrorMessage(returnFromApi.response?.data);
            console.error("Erro ao salvar notificação:", returnFromApi);
            setLoading(false);
        });
    };

    function cleanFields() {
        setTitle('');
        setContent('');
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>

            <Loading isToHidden={isLoading === false} />
            {showErrorMessage && <ErrorMessage message={errorMessage} show={showErrorMessage} setShow={setShowErrorMessage} />}

            <DialogTitle>
                Nova Notificação
            </DialogTitle>
            
            <DialogContent dividers>
                <form id="new-notification-form" onSubmit={saveNotification}>
                    <Grid container spacing={3}>
                        <Grid size={12} >
                            <TextField fullWidth
                                label="Título"
                                value={title}
                                onChange={e => setTitle(e.target.value)}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid size={12}>
                            <TextField fullWidth
                                label="Conteúdo"
                                value={content}
                                onChange={e => setContent(e.target.value)}
                                variant="outlined"
                                multiline
                                rows={4}
                            />
                        </Grid>
                    </Grid>
                </form>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} disabled={isLoading}>Cancelar</Button>
                <Button
                    type="submit"
                    form="new-notification-form"
                    variant="contained"
                    disabled={isLoading}
                >
                    Salvar
                </Button>
            </DialogActions>
        </Dialog>
    );
}

